import React, { CSSProperties } from 'react';
import Typography from '@material-ui/core/Typography';

interface Props {
  style?: CSSProperties;
}

const H4: React.FC<Props> = ({ children, style }) => {
  return (
    <Typography variant="h4" style={style}>
      {children}
    </Typography>
  );
};

export default H4 as React.ComponentType<Props>;
